export default __webpack_public_path__ + "static/Raphaël-34f1255138e6f0c8a762e4adce049e6d.webp";